(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'embeddedVideo', {
            bindings: {
                content: '<'
            },
            templateUrl:  'app/views/partials/content/video.html',
            controller:   VideoController,
            controllerAs: 'vm',

            renderingOptions: {
                'video': {
                    inputs:    [
                        'content="::content.asset_contents"'
                    ],
                    classes:   [ 'block block__video' ],
                    wrapStart: '<div class="centraliser">',
                    wrapEnd:   '</div>'
                }
            },

            renderingOptionsOverrides: {
                nested: {
                    'video': {
                        wrapStart:     null,
                        wrapEnd:       null,
                        parentClasses: [ 'block__video' ],
                        classes:       null
                    }
                }
            }
        });



    /**
     * Component for an embedded video with an image cover.
     *
     * @param {Lodash} _
     * @param {DataService} DataService
     * @param {LoggerFactory} LoggerFactory
     * @param {ng.IRootScopeService} $rootScope
     * @param {ng.IScope} $scope
     * @param {uirouter.Transitions} $transitions
     * @param {Object} TEXTS
     */
    function VideoController(
        _,
        DataService,
        LoggerFactory,
        $rootScope,
        $scope,
        $transitions,
        TEXTS
    ){

        /** @type {angular.IController} */
        var vm = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @constant */
        var COUNTRY_CODE_CHINA = 'CN';


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'VideoController' );





        /* ===== EXPOSE TO THE SCOPE ======================================== */


        $scope._ = TEXTS.GENERIC.VIDEO;





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        vm.playVideo            = playVideo;
        vm.playVideoByKeyPress  = playVideoByKeyPress;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        vm.$onInit = function() {
            /** Controller's API. */
            vm.show      = false;

            //TODO: Clean up after v1.12.0 has been released and content migrated!
            if ( vm.content.hasOwnProperty( 'id' ) ){
                initVideo();
            } else {
                initOldVideo();
            }

            setWatchers();
        };





        /* ===== PUBLIC METHODS ============================================= */


        function playVideo() {
            vm.show = true;
        }


        function playVideoByKeyPress( $event ) {
            if ( $event.keyCode === 13 ){ // ENTER key press
                vm.playVideo();
            }
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */



        //TODO: Clean up after v1.12.0 has been released and content fully migrated (if it every happens)!
        function initOldVideo() {
            vm.video = {
                id:             vm.content.videoLink,
                title:          vm.content.heading1,
                description:    vm.content.content,
                coverImage:     vm.content.videoImage,
            }
        }


        function initVideo() {
            DataService.getClientsCountryCode().then( function( countryCode ) {
                var ATTRIBUTE_CODE_CHINA = COUNTRY_CODE_CHINA.toLowerCase();

                // If International-China is selected and chinese video is available in the response, serve it!
                if ( countryCode === COUNTRY_CODE_CHINA && vm.content.hasOwnProperty( ATTRIBUTE_CODE_CHINA )){
                    _.defaults( vm.content[ ATTRIBUTE_CODE_CHINA ], vm.content );
                    delete vm.content[ ATTRIBUTE_CODE_CHINA ][ ATTRIBUTE_CODE_CHINA ];

                    vm.video = vm.content[ ATTRIBUTE_CODE_CHINA ];
                    vm.loadChineseVideo = true;
                } else {
                    vm.video = vm.content;
                }
            }).catch( function( err ){
                logger.warn( "Cannot detect a country of user's origin - Reverting to the default video.", err );

                vm.video = vm.content;
            });
        }


        function setWatchers() {
            var deregisterHook = $transitions.onSuccess( { to: '**' }, function() {
                vm.show = false;
                deregisterHook();
            });
        }


    }



    VideoController.$inject = [ '_', 'DataService', 'LoggerFactory', '$rootScope', '$scope', '$transitions', 'TEXTS' ];
})();
